<app-shared-login
[loginError]="loginError$ | async">
</app-shared-login>